import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useCurrentUser } from "~/features/auth/hooks/use-current-user";

interface WorkflowTabsProps {
  branchUid: string;
  currentPath: string;
}

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
`;

const Tab = styled.button<{ $active: boolean }>`
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ $active }) => ($active ? "#000938" : "#696F8C")};
  background-color: ${({ $active }) => ($active ? "rgba(49, 62, 131, 0.08)" : "transparent")};
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;

  &:hover {
    background-color: rgba(49, 62, 131, 0.08);
  }
`;

const TABS = [
  { labelKey: "gnb.workflowTabs.resources", path: "resources" },
  { labelKey: "gnb.workflowTabs.cameraMapping", path: "camera-mapping" },
  { labelKey: "gnb.workflowTabs.analysisDraft", path: "analysis-draft" },
  { labelKey: "gnb.workflowTabs.versions", path: "versions" },
] as const;

export function WorkflowTabs({ branchUid, currentPath }: WorkflowTabsProps) {
  const navigate = useNavigate();
  const { t } = useTranslation("shared");
  const { data: currentUser } = useCurrentUser();

  const visibleTabs = currentUser?.isStaff
    ? TABS
    : TABS.filter((tab) => tab.path !== "resources");

  return (
    <TabContainer>
      {visibleTabs.map((tab) => {
        const fullPath = `/branch/${branchUid}/${tab.path}`;
        const isActive = currentPath.includes(tab.path);

        return (
          <Tab key={tab.path} $active={isActive} onClick={() => navigate(fullPath)}>
            {t(tab.labelKey)}
          </Tab>
        );
      })}
    </TabContainer>
  );
}
